import { forwardRef } from 'react';
import { Button } from '@mui/material';
import { useWagmiAuth } from 'app/providers';
import { defaultChain, shortenPhrase, useSupportedChains } from 'shared';
import { SwitchNetworkButton } from 'shared/ui/buttons';

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const DesktopButton = forwardRef<HTMLButtonElement, Props>(({ onClick }, ref) => {
  const { state } = useWagmiAuth();
  const { isSupported } = useSupportedChains();

  if (!isSupported) {
    return (
      <SwitchNetworkButton chainId={defaultChain.id} sx={{ fontSize: 14, fontWeight: 500, width: '165px', px: 1.5 }} />
    );
  }

  return (
    <Button
      id="connect-button"
      ref={ref}
      onClick={onClick}
      variant="outlined"
      sx={{
        fontSize: 14,
        fontWeight: 400,
        px: 2,
        width: '145px',
        whiteSpace: 'nowrap',
      }}
    >
      {state.isAuthorized ? shortenPhrase(state.address, 6) : 'Connect wallet'}
    </Button>
  );
});
